import { Grid } from "@trussworks/react-uswds";
import { ReactComponent as CheckUSWDS } from "../../images/check2.svg";

import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ReactNode, useState } from "react";
import Modal from "../Modal";

const TitleStyle = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
  color: #1E6692;
`;

const BoldP = styled.p`
  font-weight: bold;
`;

const GetBhaLicensed = (
  isMobile: boolean
): [content: ReactNode, isLicensed: boolean] => {
  const { t } = useTranslation();
  //let fakeMobile=true;
  let licenseTextParts = t("licenseText").split("####");
  let modalContent: ReactNode = isMobile ? (
    <div className="border-bottom border-bottom-lighter">
      <div id={"providerLicensed"}>
        <Grid
          row
          mobile={{ col: true }}
          className="flex-justify-center tablet:flex-justify flex-align-center"
        >
          <TitleStyle>{t("isLicensedTitle")}</TitleStyle>
          <div>
            <p>{licenseTextParts[0]}</p>
            <p>{licenseTextParts[1]}</p>
            <ul>
              <li>{licenseTextParts[6]}</li>
              <li>{licenseTextParts[7]}</li>
              <li>{licenseTextParts[8]}</li>
            </ul>
            <p>{licenseTextParts[2]}</p>
          </div>
          <div>
            <BoldP>{licenseTextParts[3]}</BoldP>
            <p>
              {licenseTextParts[4]}{" "}
              <a
                href={t("surveyLink")}
                className="usa-link usa-link--external"
              >
                {licenseTextParts[5]}
              </a>
            </p>
          </div>
        </Grid>
      </div>
    </div>
  ) : (
    <div className="border-bottom border-bottom-lighter">
      <div id={"providerLicensed"}>
        <Grid
          row
          mobile={{ col: true }}
          className="flex-justify-center tablet:flex-justify flex-align-center"
        >
          <TitleStyle>{t("isLicensedTitle")}</TitleStyle>
          <div>
            <p>{licenseTextParts[0]}</p>
            <p>{licenseTextParts[1]}</p>
            <ul>
              <li>{licenseTextParts[6]}</li>
              <li>{licenseTextParts[7]}</li>
              <li>{licenseTextParts[8]}</li>
            </ul>
            <p>{licenseTextParts[2]}</p>
          </div>
          <div>
            <BoldP>{licenseTextParts[3]}</BoldP>
            <p>
              {licenseTextParts[4]}{" "}
              <a
                href={t("surveyLink")}
                className="usa-link usa-link--external"
                target="blank"
              >
                {licenseTextParts[5]}
              </a>
            </p>
          </div>
        </Grid>
      </div>
    </div>
  );
  return [modalContent, true];
};

type ProviderLicenseCardProps = {
  isMobile: boolean;
  isBhaLicensed: boolean;
};

export default function ProviderLicenseCard({
  isMobile,
  isBhaLicensed,
}: ProviderLicenseCardProps) {
  const { t } = useTranslation();
  let [content] = GetBhaLicensed(isMobile);
  const [isOpen, setIsOpen] = useState(false);
  if (isBhaLicensed) {
    return isOpen ? (
      <>
        <a
          className="usa-link"
          onClick={() => setIsOpen(!isOpen)}
        >
          <CheckUSWDS className="data-icon width-3 margin-right-1" />
          {t("isLicensedTitle")}
        </a>
        <Modal
          isOpen={isOpen}
          toggle={() => setIsOpen(!isOpen)}
          buttonText={t("close")}
        >
          {content}
        </Modal>
      </>
    ) : (
      <>
        <a
          style={{cursor: "pointer"}}
          className="usa-link"
          onClick={() => setIsOpen(!isOpen)}
        >
          <CheckUSWDS className="data-icon width-3 margin-right-1" />
          {t("isLicensedTitle")}
        </a>
      </>
    );
  } else {
    return <></>;
  }
}
